module.exports = __webpack_public_path__ + "img/collar buttons quantity.5e8870b3.png";